import { ContactInfoComponent } from './contact-info/contact-info.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountSettingComponent } from './account-setting/account-setting.component';
import { UpdateEmailComponent } from './update-email/update-email.component';
import { NotificationPreferenceComponent } from './notification-preference/notification-preference.component';
import { ContactVerifyComponent } from './contact-verify/contact-verify.component';

const routes: Routes = [
 { path: 'Profile/AccountSetting', component: AccountSettingComponent, },
 { path: 'Profile/AccountSetting/UpdateEmail', component: UpdateEmailComponent, },
 { path: 'reset_email/verify/:account_id/:token', component: UpdateEmailComponent, },
 { path: ':internal-user/account-search/account-setting/:search-key', component: AccountSettingComponent, },
 { path: ':internal-user/account-setting/update-email', component: UpdateEmailComponent, },
 { path: 'notification-preference', component: NotificationPreferenceComponent, },
 { path: 'contact-info', component: ContactInfoComponent, },
 { path: 'contact-info/:account_setting', component: ContactInfoComponent, },
 { path: 'contact-verify', component: ContactVerifyComponent, },
 { path: 'contact-verify/:account_setting', component: ContactVerifyComponent, }
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/profile/profile-routing.module.ts